import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  CircularProgress
} from '@material-ui/core';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { AuditElement } from './Audit.interface';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const Styled = {
  TreeNode: styled.div`
    .tree-node-link {
      display: flex;
      padding: 5px;
      width: 100%;
      background-color: #d9e4ea;
      color: #565656;
      font-weight: bold;
      border-bottom: solid 1px #ccc;
      align-items: center;
      cursor: pointer;
      &.collapsed .expand-icon {
        transform: rotate(-90deg);
      }

      .expand-icon {
        transition: transform 300ms ease-out;
        margin-right: 10px;
      }
    }
    .tree-node-children {
      transition: max-height 300ms cubic-bezier(1, 0, 1, 0);
      max-height: 9000px;
      overflow: hidden;
      &.collapsed {
        transition: max-height 300ms cubic-bezier(0, 1, 0, 1);
        max-height: 0;
      }
    }
  `,
  UnidentifiedControls: styled.div`
    font-weight: 500;
    color: red;
  `
};

const AuditControlElements: React.FC<{
  elements: AuditElement[];
  depth?: number;
  onToggleElement: (element: AuditElement) => void;
  onSelectElement: (element: AuditElement) => void;
}> = ({ depth = 0, elements, onToggleElement, onSelectElement }) => {
  return (
    <Fragment>
      {elements.map((element: AuditElement) => {
        const { control, isLoading = true } = element;
        return element.type === 'section' ? (
          <Styled.TreeNode className='tree-node' key={element.title}>
            <div
              className={`tree-node-link depth-${depth} ${
                element.collapsed ? 'collapsed' : 'expanded'
              }`}
              onClick={() => onToggleElement(element)}
            >
              <ExpandMoreIcon className='expand-icon' />
              {element.title}
            </div>
            {element.elements && (
              <div
                className={`tree-node-children ${
                  element.collapsed ? 'collapsed' : 'expanded'
                }`}
              >
                <AuditControlElements
                  depth={depth + 1}
                  elements={element.elements}
                  onToggleElement={onToggleElement}
                  onSelectElement={onSelectElement}
                />
              </div>
            )}
          </Styled.TreeNode>
        ) : (
          <Table key={control} className='control-table'>
            <TableBody>
              <TableRow hover onClick={() => onSelectElement(element)}>
                <TableCell className={`control depth-${depth}`}>
                  {!element.answer ? (
                    isLoading ? (
                      control
                    ) : (
                      <Styled.UnidentifiedControls>
                        {control}
                      </Styled.UnidentifiedControls>
                    )
                  ) : (
                    control
                  )}
                </TableCell>
                <TableCell className='answer'>
                  {isLoading ? (
                    <CircularProgress style={{ width: 20, height: 20 }} />
                  ) : (
                    element.answer
                  )}
                </TableCell>
                <TableCell className='comment'>
                  {!isLoading && (
                    <div className='comment-truncate'>
                      {element.comment?.replace(/<.*?>/g, '')}
                    </div>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        );
      })}
    </Fragment>
  );
};

export default AuditControlElements;
